export default __webpack_public_path__ + "202545f284701918aba7b1d3e2f0a6ca.png";